import get from 'lodash/get'
import numeral from 'numeral'
import UseabilityService from '@/api/UseabilityService'
import PaymentService from '@/api/PaymentService'
import ShopService from '@/api/ShopService'
import { HAS_FEE_APP_MODULES } from '../../helpers/enum'

export const transformMonthlyUsed = (item = {}) => {
  return {
    'branch': {
      'freeLeftTotal': item.branch && item.branch.free_left_total,
      'freeTotal': item.branch && item.branch.free_total,
      'countAllTotal': item.branch && item.branch.count_all_total,
      'countChargeTotal': item.branch && item.branch.count_charge_total,
      'amountTotal': item.branch && item.branch.amount_total,
    },
    'warehouse': {
      'freeLeftTotal': item.warehouse && item.warehouse.free_left_total,
      'freeTotal': item.warehouse && item.warehouse.free_total,
      'countAllTotal': item.warehouse && item.warehouse.count_all_total,
      'countChargeTotal': item.warehouse && item.warehouse.count_charge_total,
      'amountTotal': item.warehouse && item.warehouse.amount_total,
    },
    'user': {
      'freeLeftTotal': item.user && item.user.free_left_total,
      'freeTotal': item.user && item.user.free_total,
      'countAllTotal': item.user && item.user.count_all_total,
      'countChargeTotal': item.user && item.user.count_charge_total,
      'amountTotal': item.user && item.user.amount_total,
    },
    'record': {
      'freeLeftTotal': item.record && item.record.free_left_total,
      'freeTotal': item.record && item.record.free_total,
      'countAllTotal': item.record && item.record.count_all_total,
      'countChargeTotal': item.record && item.record.count_charge_total,
      'count': {
        'app_1_module_1': get(item, 'record.count.app_1_module_1', 0),
        'app_2_module_1': get(item, 'record.count.app_2_module_1', 0),
        'app_3_module_4': get(item, 'record.count.app_3_module_4', 0),
        'app_3_module_5': get(item, 'record.count.app_3_module_5', 0),
        'app_3_module_6': get(item, 'record.count.app_3_module_6', 0),
        'app_3_module_7': get(item, 'record.count.app_3_module_7', 0),
        'app_3_module_8': get(item, 'record.count.app_3_module_8', 0),
        'app_4_module_1': get(item, 'record.count.app_4_module_1', 0),
        'app_5_module_1': get(item, 'record.count.app_5_module_1', 0),
        'app_6_module_1': get(item, 'record.count.app_6_module_1', 0),
        'app_11_module_2': get(item, 'record.count.app_11_module_2', 0),
        'app_11_module_3': get(item, 'record.count.app_11_module_3', 0),
        'app_12_module_2': get(item, 'record.count.app_12_module_2', 0),
        'app_12_module_3': get(item, 'record.count.app_12_module_3', 0),
        'app_13_module_1': get(item, 'record.count.app_13_module_1', 0),
        'app_14_module_1': get(item, 'record.count.app_14_module_1', 0),
      },
      'amountTotal': item.record && item.record.amount_total,
    },
    'file': {
      'freeLeftTotal': item.file && item.file.free_left_total,
      'freeTotal': item.file && item.file.free_total,
      'countAllTotal': numeral(get(item, 'file.count_all_total', 0)).format('0,0.00'),
      'countChargeTotal': numeral(get(item, 'file.count_charge_total', 0)).format('0,0.00'),
      'count': {
        'app_2_module_1': numeral(get(item, 'file.count.app_2_module_1', 0)).format('0,0.00'),
        'app_3_module_4': numeral(get(item, 'file.count.app_3_module_4', 0)).format('0,0.00'),
        'app_3_module_5': numeral(get(item, 'file.count.app_3_module_5', 0)).format('0,0.00'),
        'app_3_module_6': numeral(get(item, 'file.count.app_3_module_6', 0)).format('0,0.00'),
        'app_3_module_7': numeral(get(item, 'file.count.app_3_module_7', 0)).format('0,0.00'),
        'app_3_module_8': numeral(get(item, 'file.count.app_3_module_8', 0)).format('0,0.00'),
        'app_4_module_1': numeral(get(item, 'file.count.app_4_module_1', 0)).format('0,0.00'),
        'app_5_module_1': numeral(get(item, 'file.count.app_5_module_1', 0)).format('0,0.00'),
        'app_6_module_1': numeral(get(item, 'file.count.app_6_module_1', 0)).format('0,0.00'),
        'app_12_module_2': numeral(get(item, 'file.count.app_12_module_2', 0)).format('0,0.00'),
        'app_12_module_3': numeral(get(item, 'file.count.app_12_module_3', 0)).format('0,0.00'),
        'app_14_module_1': numeral(get(item, 'file.count.app_14_module_1', 0)).format('0,0.00'),
      },
      'amountTotal': item.file && item.file.amount_total,
    },
    'messageLine': {
      'freeLeftTotal': item.message_line && item.message_line.free_left_total,
      'freeTotal': item.message_line && item.message_line.free_total,
      'countAllTotal': item.message_line && item.message_line.count_all_total,
      'countChargeTotal': item.message_line && item.message_line.count_charge_total,
      'count': {
        'app_1_module_1': get(item, 'message_line.count.app_1_module_1', 0),
        'app_1_module_2': get(item, 'message_line.count.app_1_module_2', 0),
        'app_3_module_3': get(item, 'message_line.count.app_3_module_3', 0),
      },
      'amountTotal': item.message_line && item.message_line.amount_total,
    },
    'email': {
      'freeLeftTotal': item.email && item.email.free_left_total,
      'freeTotal': item.email && item.email.free_total,
      'countAllTotal': item.email && item.email.count_all_total,
      'countChargeTotal': item.email && item.email.count_charge_total,
      'amountTotal': item.email && item.email.amount_total,
      'count': {
        'app_1_module_1': get(item, 'email.count.app_1_module_1', 0),
      },
    },
    'qrcode': {
      'freeLeftTotal': item.qrcode && item.qrcode.free_left_total,
      'freeTotal': item.qrcode && item.qrcode.free_total,
      'countAllTotal': item.qrcode && item.qrcode.count_all_total,
      'countChargeTotal': item.qrcode && item.qrcode.count_charge_total,
      'amountTotal': item.qrcode && item.qrcode.amount_total,
      'count': {
        'app_1_module_5': get(item, 'qrcode.count.app_1_module_5', 0),
      },
    },
    'apps': item.apps ? item.apps.map((app) => {
      return {
        'amountTotal': app.amount_total,
        'currency': app.currency,
        'appId': app.app_id,
        'moduleId': app.module_id,
      }
    }) : [],
    'total': item.total,
  }
}

export const transformInvoice = (item) => {
  return {
    'invId': item._id,

    'appDateStart': item.app_date_start,
    'appDateEnd': item.app_date_end,
    'appUsedRecords': item.app_used_records,
    'appUsedRecordsMin': item.app_used_records_min,
    'appUsedRecordsMax': item.app_used_records_max,
    'appAmountTotal': item.app_amount_total,
    'appUnitPrice': item.app_unit_price,

    'branchDateStart': item.branch_date_start,
    'branchDateEnd': item.branch_date_end,
    'branchUsedCount': item.branch_used_count,
    'branchUsedCountMin': item.branch_used_count_min,
    'branchUsedCountMax': item.branch_used_count_max,
    'branchAmountTotal': item.branch_amount_total,
    'branchUnitPrice': item.branch_unit_price,

    'warehouseDateStart': item.warehouse_date_start,
    'warehouseDateEnd': item.warehouse_date_end,
    'warehouseUsedCount': item.warehouse_used_count,
    'warehouseUsedCountMin': item.warehouse_used_count_min,
    'warehouseUsedCountMax': item.warehouse_used_count_max,
    'warehouseAmountTotal': item.warehouse_amount_total,
    'warehouseUnitPrice': item.warehouse_unit_price,

    'userDateStart': item.user_date_start,
    'userDateEnd': item.user_date_end,
    'userUsedCount': item.user_used_count,
    'userUsedCountMin': item.user_used_count_min,
    'userUsedCountMax': item.user_used_count_max,
    'userAmountTotal': item.user_amount_total,
    'userUnitPrice': item.user_unit_price,

    'fileDateStart': item.file_date_start,
    'fileDateEnd': item.file_date_end,
    'fileUsedSizeMb': item.file_used_size_mb,
    'fileUsedSizeMbMin': item.file_used_size_mb_min,
    'fileUsedSizeMbMax': item.file_used_size_mb_max,
    'fileAmountTotal': item.file_amount_total,
    'fileUnitPrice': item.file_unit_price,

    'lineDateStart': item.line_date_start,
    'lineDateEnd': item.line_date_end,
    'lineMessageCount': item.line_message_count,
    'lineMessageCountMin': item.line_message_count_min,
    'lineMessageCountMax': item.line_message_count_max,
    'lineAmountTotal': item.line_amount_total,
    'lineUnitPrice': item.line_unit_price,

    'emailDateStart': item.email_date_start,
    'emailDateEnd': item.email_date_end,
    'emailCount': item.email_count,
    'emailCountMin': item.email_count_min,
    'emailCountMax': item.email_count_max,
    'emailAmountTotal': item.email_amount_total,
    'emailUnitPrice': item.email_unit_price,

    'qrcodeDateStart': item.qrcode_date_start,
    'qrcodeDateEnd': item.qrcode_date_end,
    'qrcodeCount': item.qrcode_count,
    'qrcodeCountMin': item.qrcode_count_min,
    'qrcodeCountMax': item.qrcode_count_max,
    'qrcodeAmountTotal': item.qrcode_amount_total,
    'qrcodeUnitPrice': item.qrcode_unit_price,

    'apps': item.apps ? item.apps.map((app) => {
      return {
        'amountTotal': app.amount_total,
        'appId': app.app_id,
        'moduleId': app.module_id,
        'dateStart': app.date_start,
        'dateEnd': app.date_end,
        'unitPrice': app.unit_price,
      }
    }) : [],

    'tax': item.tax,
    'discount': item.discount,
    'dateStart': item.date_start,
    'dateEnd': item.date_end,
    'total': item.total,
    'code': item.code,
    'status': item.status,
    'createdAt': item.created_at,
  }
}

export const transformInvoices = (items) => {
  return items.map((item) => transformInvoice(item))
}

export const transformInvoiceCreditRecords = (items) => {
  return items.map((item) => {
    return {
      'invId': item.inv_id,
      'countTotal': item.count_total,
      'amountPerUnit': item.amount_per_unit,
      'amountTotal': item.amount_total,
      'createdAt': item.created_at,
    }
  })
}

export const transformInvoiceCreditBranches = (items) => {
  return items.map((item) => {
    return {
      'invId': item.inv_id,
      'countTotal': item.count_total,
      'amountPerUnit': item.amount_per_unit,
      'amountTotal': item.amount_total,
      'createdAt': item.created_at,
    }
  })
}

export const transformInvoiceCreditWarehouses = (items) => {
  return items.map((item) => {
    return {
      'invId': item.inv_id,
      'countTotal': item.count_total,
      'amountPerUnit': item.amount_per_unit,
      'amountTotal': item.amount_total,
      'createdAt': item.created_at,
    }
  })
}

export const transformInvoiceCreditUsers = (items) => {
  return items.map((item) => {
    return {
      'invId': item.inv_id,
      'countTotal': item.count_total,
      'amountPerUnit': item.amount_per_unit,
      'amountTotal': item.amount_total,
      'createdAt': item.created_at,
    }
  })
}

export const transformInvoiceCreditApps = (items) => {
  return items.map((item) => {
    return {
      'invId': item.inv_id,
      'appId': item.app_id,
      'moduleId': item.module_id,
      'amountPerUnit': item.amount_per_unit,
      'amountTotal': item.amount_total,
      'createdAt': item.created_at,
    }
  })
}

export const transformInvoiceCreditFiles = (items) => {
  return items.map((item) => {
    return {
      'invId': item.inv_id,
      'sizeMbTotal': item.size_mb_total,
      'amountPerUnit': item.amount_per_unit,
      'amountTotal': item.amount_total,
      'createdAt': item.created_at,
    }
  })
}

export const transformInvoiceCreditMessages = (items) => {
  return items.map((item) => {
    return {
      'invId': item.inv_id,
      'countTotal': item.count_total,
      'amountPerUnit': item.amount_per_unit,
      'amountTotal': item.amount_total,
      'createdAt': item.created_at,
    }
  })
}

export const transformInvoiceCreditEmails = (items) => {
  return items.map((item) => {
    return {
      'invId': item.inv_id,
      'countTotal': item.count_total,
      'amountPerUnit': item.amount_per_unit,
      'amountTotal': item.amount_total,
      'createdAt': item.created_at,
    }
  })
}

export const transformInvoiceCreditQRCodes = (items) => {
  return items.map((item) => {
    return {
      'invId': item.inv_id,
      'countTotal': item.count_total,
      'amountPerUnit': item.amount_per_unit,
      'amountTotal': item.amount_total,
      'createdAt': item.created_at,
    }
  })
}

export const transformTranactionOrders = (items = []) => {
  return items.map((item) => {
    return {
      'detail': item.detail,
      'quantity': item.quantity,
    }
  })
}

export const transformTranaction = (item = {}) => {
  return {
    'transactionId': item._id,
    'type': item.type,
    'chargeId': item.charge_id,
    'uuid': item.uuid,
    'code': item.code,
    'detail': item.detail,
    'orders': transformTranactionOrders(item.orders),
    'fullName': item.full_name,
    'city': item.city,
    'address1': item.address1,
    'address2': item.address2,
    'zipcode': item.zipcode,
    'countryCode': item.country_code,
    'phoneNumber': item.phone_number,
    'paymentMethod': item.payment_method,
    'cardNumber': item.card_number,
    'paidAmount': item.paid_amount,
    'paidAt': item.paid_at,
    'currency': item.currency,
    'createdAt': item.created_at,
  }
}

export const transformTranactions = (items) => {
  return items.map((item) => transformTranaction(item))
}

export const transformPaymentCard = (input) => {
  return {
    'cardNumber': input.card_number || null,
    'cvvNumber': input.cvv_number || null,
    'expiredDateMonth': input.expired_date_month || null,
    'expiredDateYear': input.expired_date_year || null,
    'holderName': input.holder_name || null,
  }
}

export const transformPaymentMethod = (input) => {
  return {
    'card': transformPaymentCard(input.card || {}),
    'type': input.type || null,
    'city': input.city || null,
    'address1': input.address1 || null,
    'address2': input.address2 || null,
    'zipcode': input.zipcode || null,
    'countryCode': input.country_code || null,
    'phoneNumber': input.phone_number || null,
    'createdAt': input.created_at || null,
    'updatedAt': input.updated_at || null,
  }
}

const initialAppState = {
  ...HAS_FEE_APP_MODULES.reduce((acc, cur) => {
    const key = `APPID${cur.app_id}_MODULEID${cur.module_id}`
    return {
      ...acc,
      [key]: transformInvoiceCreditApps([]),
    }
  }, {}),
}

export default {
  namespaced: true,

  state: {
    monthlyUsed: transformMonthlyUsed({}),
    monthlyUsedCreditRecordList: transformInvoiceCreditRecords([]),
    monthlyUsedCreditFileList: transformInvoiceCreditFiles([]),
    monthlyUsedCreditLineMessageList: transformInvoiceCreditMessages([]),
    monthlyUsedCreditEmailList: transformInvoiceCreditEmails([]),
    monthlyUsedCreditQRCodeList: transformInvoiceCreditQRCodes([]),
    monthlyUsedCreditBranchList: transformInvoiceCreditBranches([]),
    monthlyUsedCreditWarehouseList: transformInvoiceCreditWarehouses([]),
    monthlyUsedCreditUserList: transformInvoiceCreditUsers([]),
    monthlyUsedCreditAppList: initialAppState,
    invoiceList: transformInvoices([]),
    invoiceSingle: transformInvoice({}),
    invoiceCreditRecordList: transformInvoiceCreditRecords([]),
    invoiceCreditFileList: transformInvoiceCreditFiles([]),
    invoiceCreditLineMessageList: transformInvoiceCreditMessages([]),
    invoiceCreditEmailList: transformInvoiceCreditEmails([]),
    invoiceCreditQRCodeList: transformInvoiceCreditQRCodes([]),
    invoiceCreditBranchList: transformInvoiceCreditBranches([]),
    invoiceCreditWarehouseList: transformInvoiceCreditWarehouses([]),
    invoiceCreditUserList: transformInvoiceCreditUsers([]),
    invoiceCreditAppList: initialAppState,
    transactionSingle: transformTranaction({}),
    transactionList: transformTranactions([]),
    paymentMethod: transformPaymentMethod({}),

    purchasePackage: {
      key: null,
      month: null,
      total: null,
      detail: null,
    },
  },

  mutations: {
    setMonthlyUsed (state, data) {
      state.monthlyUsed = transformMonthlyUsed(data)
    },
    setMonthlyUsedCreditRecordList (state, data) {
      state.monthlyUsedCreditRecordList = transformInvoiceCreditRecords(data)
    },
    setMonthlyUsedCreditFileList (state, data) {
      state.monthlyUsedCreditFileList = transformInvoiceCreditFiles(data)
    },
    setMonthlyUsedCreditLineMessage (state, data) {
      state.monthlyUsedCreditLineMessageList = transformInvoiceCreditMessages(data)
    },
    setMonthlyUsedCreditEmailList (state, data) {
      state.monthlyUsedCreditEmailList = transformInvoiceCreditEmails(data)
    },
    setMonthlyUsedCreditQRCodeList (state, data) {
      state.monthlyUsedCreditQRCodeList = transformInvoiceCreditQRCodes(data)
    },
    setMonthlyUsedCreditBranchList (state, data) {
      state.monthlyUsedCreditBranchList = transformInvoiceCreditBranches(data)
    },
    setMonthlyUsedCreditWarehouseList (state, data) {
      state.monthlyUsedCreditWarehouseList = transformInvoiceCreditWarehouses(data)
    },
    setMonthlyUsedCreditUserList (state, data) {
      state.monthlyUsedCreditUserList = transformInvoiceCreditUsers(data)
    },
    setMonthlyUsedCreditAppList (state, { data, params }) {
      const { app_id, module_id } = params
      state.monthlyUsedCreditAppList[`APPID${app_id}_MODULEID${module_id}`] = transformInvoiceCreditApps(data)
    },
    setInvoiceList (state, data) {
      state.invoiceList = transformInvoices(data)
    },
    setInvoiceSingle (state, data) {
      state.invoiceSingle = transformInvoice(data)
    },
    setInvoiceCreditRecordList (state, data) {
      state.invoiceCreditRecordList = transformInvoiceCreditRecords(data)
    },
    setInvoiceCreditFileList (state, data) {
      state.invoiceCreditFileList = transformInvoiceCreditFiles(data)
    },
    setInvoiceCreditLineMessage (state, data) {
      state.invoiceCreditLineMessageList = transformInvoiceCreditMessages(data)
    },
    setInvoiceCreditEmailList (state, data) {
      state.invoiceCreditEmailList = transformInvoiceCreditEmails(data)
    },
    setInvoiceCreditQRCodeList (state, data) {
      state.invoiceCreditQRCodeList = transformInvoiceCreditQRCodes(data)
    },
    setInvoiceCreditBranchList (state, data) {
      state.invoiceCreditBranchList = transformInvoiceCreditBranches(data)
    },
    setInvoiceCreditWarehouseList (state, data) {
      state.invoiceCreditWarehouseList = transformInvoiceCreditWarehouses(data)
    },
    setInvoiceCreditUserList (state, data) {
      state.invoiceCreditUserList = transformInvoiceCreditUsers(data)
    },
    setInvoiceCreditAppList (state, { data, params }) {
      const { app_id, module_id } = params
      state.invoiceCreditAppList[`APPID${app_id}_MODULEID${module_id}`] = transformInvoiceCreditApps(data)
    },
    setTransactionSingle (state, data) {
      state.transactionSingle = transformTranaction(data)
    },
    setTransactionList (state, data) {
      state.transactionList = transformTranactions(data)
    },
    setPaymentMethod (state, data) {
      state.paymentMethod = transformPaymentMethod(data)
    },
    setPurchasePackage (state, data) {
      state.purchasePackage = {
        key: data.key,
        month: data.month,
        total: data.total,
        detail: data.detail,
      }
    },
  },

  actions: {
    async getMonthlyUsed ({ commit }, date) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsed') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMonthlyUsed')
        const response = await UseabilityService.getMonthlyUsed(date)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMonthlyUsed')
        result = response.data
        if (result.success) {
          commit('setMonthlyUsed', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },

    async getMonthlyUsedCreditRecordList ({ commit }, date) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsedCreditRecordList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMonthlyUsedCreditRecordList')
        const response = await UseabilityService.getMonthlyUsedCreditRecordList(date)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMonthlyUsedCreditRecordList')
        result = response.data
        if (result.success) {
          commit('setMonthlyUsedCreditRecordList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getMonthlyUsedCreditFileList ({ commit }, date) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsedCreditFileList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMonthlyUsedCreditFileList')
        const response = await UseabilityService.getMonthlyUsedCreditFileList(date)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMonthlyUsedCreditFileList')
        result = response.data
        if (result.success) {
          commit('setMonthlyUsedCreditFileList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getMonthlyUsedCreditLineMessageList ({ commit }, date) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsedCreditLineMessageList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMonthlyUsedCreditLineMessageList')
        const response = await UseabilityService.getMonthlyUsedCreditLineMessageList(date)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMonthlyUsedCreditLineMessageList')
        result = response.data
        if (result.success) {
          commit('setMonthlyUsedCreditLineMessage', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getMonthlyUsedCreditEmailList ({ commit }, date) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsedCreditEmailList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMonthlyUsedCreditEmailList')
        const response = await UseabilityService.getMonthlyUsedCreditEmailList(date)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMonthlyUsedCreditEmailList')
        result = response.data
        if (result.success) {
          commit('setMonthlyUsedCreditEmailList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getMonthlyUsedCreditQRCodeList ({ commit }, date) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsedCreditQRCodeList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMonthlyUsedCreditQRCodeList')
        const response = await UseabilityService.getMonthlyUsedCreditQRCodeList(date)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMonthlyUsedCreditQRCodeList')
        result = response.data
        if (result.success) {
          commit('setMonthlyUsedCreditQRCodeList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getMonthlyUsedCreditBranchList ({ commit }, date) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsedCreditBranchList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMonthlyUsedCreditBranchList')
        const response = await UseabilityService.getMonthlyUsedCreditBranchList(date)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMonthlyUsedCreditBranchList')
        result = response.data
        if (result.success) {
          commit('setMonthlyUsedCreditBranchList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getMonthlyUsedCreditWarehouseList ({ commit }, date) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsedCreditWarehouseList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMonthlyUsedCreditWarehouseList')
        const response = await UseabilityService.getMonthlyUsedCreditWarehouseList(date)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMonthlyUsedCreditWarehouseList')
        result = response.data
        if (result.success) {
          commit('setMonthlyUsedCreditWarehouseList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getMonthlyUsedCreditUserList ({ commit }, date) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsedCreditUserList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMonthlyUsedCreditUserList')
        const response = await UseabilityService.getMonthlyUsedCreditUserList(date)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMonthlyUsedCreditUserList')
        result = response.data
        if (result.success) {
          commit('setMonthlyUsedCreditUserList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getMonthlyUsedCreditAppList ({ commit }, { date, params }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMonthlyUsedCreditAppList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        const response = await UseabilityService.getMonthlyUsedCreditAppList(date, params)
        this.dispatch('Loading', false)
        result = response.data
        if (result.success) {
          commit('setMonthlyUsedCreditAppList', {
            data: result.data,
            params,
          })
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },

    async getInvoiceList ({ commit }, params) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceList')
        const response = await UseabilityService.getInvoiceList(params)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceList')
        result = response.data
        if (result.success) {
          commit('setInvoiceList', result.data)
          this.dispatch('setPagination', result.meta)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceSingle ({ commit }, { id }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceSingle') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceSingle')
        const response = await UseabilityService.getInvoiceSingle(id)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceSingle')
        result = response.data
        if (result.success) {
          commit('setInvoiceSingle', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceCreditRecordList ({ commit }, { id }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceCreditRecordList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceCreditRecordList')
        const response = await UseabilityService.getInvoiceCreditRecordList(id)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceCreditRecordList')
        result = response.data
        if (result.success) {
          commit('setInvoiceCreditRecordList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceCreditFileList ({ commit }, { id }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceCreditFileList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceCreditFileList')
        const response = await UseabilityService.getInvoiceCreditFileList(id)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceCreditFileList')
        result = response.data
        if (result.success) {
          commit('setInvoiceCreditFileList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceCreditLineMessageList ({ commit }, { id }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceCreditLineMessageList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceCreditLineMessageList')
        const response = await UseabilityService.getInvoiceCreditLineMessageList(id)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceCreditLineMessageList')
        result = response.data
        if (result.success) {
          commit('setInvoiceCreditLineMessage', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceCreditEmailList ({ commit }, { id }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceCreditEmailList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceCreditEmailList')
        const response = await UseabilityService.getInvoiceCreditEmailList(id)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceCreditEmailList')
        result = response.data
        if (result.success) {
          commit('setInvoiceCreditEmailList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceCreditQRCodeList ({ commit }, { id }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceCreditQRCodeList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceCreditQRCodeList')
        const response = await UseabilityService.getInvoiceCreditQRCodeList(id)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceCreditQRCodeList')
        result = response.data
        if (result.success) {
          commit('setInvoiceCreditQRCodeList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceCreditBranchList ({ commit }, { id }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceCreditBranchList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceCreditBranchList')
        const response = await UseabilityService.getInvoiceCreditBranchList(id)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceCreditBranchList')
        result = response.data
        if (result.success) {
          commit('setInvoiceCreditBranchList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceCreditWarehouseList ({ commit }, { id }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceCreditWarehouseList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceCreditWarehouseList')
        const response = await UseabilityService.getInvoiceCreditWarehouseList(id)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceCreditWarehouseList')
        result = response.data
        if (result.success) {
          commit('setInvoiceCreditWarehouseList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceCreditUserList ({ commit }, { id }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceCreditUserList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getInvoiceCreditUserList')
        const response = await UseabilityService.getInvoiceCreditUserList(id)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getInvoiceCreditUserList')
        result = response.data
        if (result.success) {
          commit('setInvoiceCreditUserList', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getInvoiceCreditAppList ({ commit }, { id, params }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getInvoiceCreditAppList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        const response = await UseabilityService.getInvoiceCreditAppList(id, params)
        this.dispatch('Loading', false)
        result = response.data
        if (result.success) {
          commit('setInvoiceCreditAppList', {
            data: result.data,
            params,
          })
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getTransactionList ({ commit }, params) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getTransactionList') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getTransactionList')
        const response = await UseabilityService.getTransactionList(params)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getTransactionList')
        result = response.data
        if (result.success) {
          commit('setTransactionList', result.data)
          this.dispatch('setPagination', result.meta)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getMasterData ({ commit }, data) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getMasterData') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getMasterData')
        const response = await PaymentService.getMasterData()
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getMasterData')
        result = response.data
        if (result.success) {
          if (result.data) {
            commit('setPaymentMethod', result.data)
          }
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updatePaymentMethod ({ commit }, { type, data }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('updatePaymentMethod') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'updatePaymentMethod')
        const response = await PaymentService.updatePaymentMethod(type, data)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'updatePaymentMethod')
        result = response.data
        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getCharge ({ commit }, { chargeId }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getCharge') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getCharge')
        const response = await PaymentService.getCharge(chargeId)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getCharge')
        result = response.data
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getTransactionBy ({ commit }, { chargeId }) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('getCharge') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'getCharge')
        const response = await PaymentService.getTransactionBy(chargeId)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'getCharge')
        result = response.data
        if (result.success) {
          commit('setTransactionSingle', result.data.transaction || {})
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async chargeInvoice ({ commit }, data) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('chargeInvoice') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'chargeInvoice')
        const response = await PaymentService.chargeInvoice(data)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'chargeInvoice')
        result = response.data
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async chargePackage ({ commit }, data) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('chargePackage') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'chargePackage')
        const response = await PaymentService.chargePackage(data)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'chargePackage')
        result = response.data
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateBillingPreference (_, data) {
      let result
      const stillLoading = this.state.app.loadinglist.indexOf('updatePaymentMethod') >= 0
      if (stillLoading) {
        return
      }
      try {
        this.dispatch('Loading', true)
        this.dispatch('Error', null)
        this.dispatch('addLoadinglist', 'updateBillingPreference')
        const response = await ShopService.updateBillingPreference(data)
        this.dispatch('Loading', false)
        this.dispatch('removeLoadinglist', 'updateBillingPreference')
        result = response.data
        if (result.success) {
          this.dispatch('setLocalStorageShopInfo')
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    setPurchasePackage ({ commit }, data) {
      commit('setPurchasePackage', data)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/Billing.js